import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitAppointment = (data) =>
  axios.post(`${API}/appointments`, data).then((r) => r.data);

export const submitContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
